import React from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"
// import Phone from "../../components/Shared/Phone"
import classes from "./Home.module.scss"
import image1 from'../../assets/images/mmIntroBingo.jpg'
// import beach from'../../assets/images/delivery-eatBeach0.png'
// import uberMob from'../../assets/images/mdelivery-ubereats.png'
import cluster1 from'../../assets/images/mmCombo3.jpg'
import cluster2 from'../../assets/images/mmFront1.jpg'
import cluster4 from'../../assets/images/mmDessert1.jpg'
import symbol from'../../assets/images/symbol.png'

// const delivery = (
//   <div className={[classes.textBtmX, classes.deliverOut].join(' ')}>
//     <h3>Or Get it delivered to your door</h3>
//     <div className={classes.medDef}>
//       <div className={classes.deliverySec}>
//         <div className={classes.dsInner}>
//           <a href="https://www.timetoeatthebeach.com/order/restaurant/mile-marker-158-dockside-menu/76" target="_blank" rel="noopener noreferrer" className={[classes.deliveryLogo, classes.tall, classes.orange].join(' ')}>
//             <img src={beach} alt="Eat the Beach logo" className={[classes.imgResponsive, classes.fwX].join(' ')} />
//           </a>

//           <a href="https://www.ubereats.com/mobile-al/food-delivery/mile-marker-158-dockside/1DaIE_YsRbaQhhUOF-90sQ" target="_blank" rel="noopener noreferrer" className={[classes.deliveryLogo, classes.narrow].join(' ')}>
//             <img src={uberMob} alt="Uber Eats logo" className={[classes.imgResponsive, classes.mobXXX].join(' ')} />
//           </a>
//         </div>
//       </div>
//     </div>
//   </div>
// )

const home = () => {
  return (
    <div className={classes.Home}>
      <Helmet>
        <title>Waterfront Restaurant in Orange Beach, Al | Mile Marker 158 Dockside</title>
        <meta name="description" content="Mile Marker 158 Dockside serves casual cuisine from our beautiful, waterfront restaurant at The Wharf in Orange Beach, Alabama. Open every day at 11am!" />
      </Helmet>
   
      {/* <div className={classes.insideXl}>
        <div className={[classes.BannerAd, classes.XXdouble, classes.announce].join(' ')}>
          <div className={classes.contentSec}>
            <div className={[classes.event, classes.e1].join(' ')}>
              <p className={classes.p1}>May Wine Dinner</p>
              <h5>May 7<span>&nbsp;•&nbsp;</span>6pm<span>&nbsp;•&nbsp;</span>$55 per guest</h5>
              <div className={classes.annLink}><Link to="/wine-dinner" className={[classes.mileLink, classes.wineLink].join(' ')}>See Details</Link></div>
            </div>
          </div>
        </div>
      </div> */}

      <div className={classes.insideXl}>
        <div className={classes.hs1}>
          <img src={image1} alt="Waterfront dining at The Wharf, in Orange Beach - Mile Marker 158 Dockside" className={[classes.imgResponsive, classes.focal].join(' ')} />
          <div className={classes.mainTitle}>
            <h1 className={classes.h2}>Mile Marker 158 Dockside</h1>
            <h2 className={classes.h1}>Open for indoor &amp; <br/>outdoor dining</h2>

            <div className={classes.famMealsTop}>
              <div className={classes.ifm}>
                <h4>Now serving family meals togo!</h4>
                <div className={classes.clearfix}/>
                <Link to="/family-meals-togo" className={classes.mileLink}>Learn More</Link>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.famMealsRow}><div className={classes.contentSec}>
          <div className={classes.left}><p>Now serving family meals to go!</p></div>
          <div className={classes.right}><Link to="/family-meals-togo" className={classes.mileLink}>Learn More</Link></div>
        </div></div>
        {/* {delivery} */}
      </div>

      <div className={classes.hs2}>
        <div className={[classes.sectionWrap, classes.inside10].join(' ')}>
          <div className={[classes.group, classes.topRow].join(' ')}>
            <img src={symbol} alt="Mile Marker 158 Dockside compass rose from logo" className={[classes.imgResponsive, classes.symbol].join(' ')} />
            <p className={classes.textIl}><span>Mile Marker 158</span> is the newest member to our Wharf Restaurant Group family. Located <span>dockside of the Springhill Suites 
              Hotel, </span> Mile Marker has the best patio dining view around — <span>overlooking the Wharf’s Marina. </span> 
              Dining inside offers a pleasant experience with an upscale appearance, while serving <span>casual culinary cuisine</span> and <span>handcrafted cocktails.</span>
            </p>
          </div>

          <div className={[classes.flexGroup, classes.textRow].join(' ')}>
            <p>
              This <span>hidden gem</span> is the perfect place to visit, whether you're docking from a sunset or dolphin cruise, enjoying date night with your significant other, 
              or even hosting a bridal shower, wedding reception, or business luncheon. 
            </p>
            <p>
              Not only does MM 158 create a <span>relaxing dining experience,</span> they can also accommodate large gatherings and caterings. With a friendly and professional 
              catering department, Mile Marker can guarantee a memorable event.
            </p>
          </div>
        </div>
      </div>

      <div className={classes.cluster}>
        <div className={classes.inside}>
          <div className={[classes.clusterRow, classes.rLunch].join(' ')}>
            <Link to="/daily-menu" className={[classes.clusterLink, classes.lunch].join(' ')}><span>Daily Menu</span></Link>
            <img src={cluster1} alt="Mile Marker 158 Dockside indoor dining area" className={[classes.imgResponsive, classes.clusterImg].join(' ')} />
          </div>
          
          <div className={[classes.clusterRow, classes.rDinner].join(' ')}>
            <Link to="/kids-menu" className={[classes.clusterLink, classes.dinner].join(' ')}><span>Kids Menu</span></Link>
            <img src={cluster4} alt="Mile Marker 158 Dockside booth with waterfront view" className={[classes.imgResponsive, classes.clusterImg].join(' ')} />
          </div>

          <div className={[classes.clusterRow, classes.rRes].join(' ')}>
            <img src={cluster2} alt="Mile Marker 158 Dockside entrance" className={[classes.imgResponsive, classes.clusterImg].join(' ')} />
            <a href="https://www.yelp.com/biz/mile-marker-158-dockside-orange-beach?osq=Mile+Marker+158+Dockside" target="_blank" rel="noopener noreferrer" className={[classes.clusterLink, classes.res].join(' ')}><span>Reservations</span></a>
          </div>
        </div>
        <div className={classes.clearfix}></div>
        <div className={classes.bborder}></div>
        <div className={classes.clearfix}></div>
      </div>
    </div>
  )
}
export default home